'use es6';

import http from 'hub-http/clients/apiClient';
export const fetch = contentId => http.get(`content-editor/v1/module-errors/${contentId}`);